import { useIntl } from 'react-intl'
import { Medias } from '../../../../enumns/medias'
import { useMediaQuery } from '../../../../hooks/useMediaQuery'

type Props = {
  id: string
}

export const OurHistory = ({ id }: Props) => {
  const { formatMessage } = useIntl()

  const isTabletSize = useMediaQuery(`(min-width: ${Medias.XL}px)`)

  return (
    <section id={id} className="py-[100px] bg-[#4A7D9A]">
      <div className="flex flex-col items-center gap-8 px-4 h-full text-justify xl:flex-row max-w-[1264px] mx-auto">
      {!isTabletSize && (
        <h2 className="md:text-[36px] text-2xl leading-[60px] mb-4 text-center uppercase font-openSans text-[#BAF5F5] font-bold">
          {formatMessage({ id: 'OUR_HISTORY' })}
        </h2>
      )}

        <div className="min-w-[400]">
          <img
            className="w-full h-full object-cover"
            src="/our-history.png"
            alt="Imagem de 5 pessoas reuniadas em uma mesa e aparentemente participando de uma reunião"
          />
        </div>

        <div className="flex flex-col justify-between h-full xl:max-w-[832px]">
          {isTabletSize && (
            <h2 className="md:text-[36px] text-2xl leading-[60px] mb-4 text-center uppercase font-openSans text-[#BAF5F5] font-bold">
              {formatMessage({ id: 'OUR_HISTORY' })}
            </h2>
          )}
          <div className="md:text-2xl text-base md:leading-9 text-white tracking-[-1.2px] font-montserrat font-normal whitespace-pre-line">
            {formatMessage({ id: 'OUR_HISTORY_TEXT' })}
          </div>
        </div>
      </div>
    </section>
  )
}
